import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider } from "@mui/material/styles";
import { colors } from "healthex-common/colors";
import { observer } from "mobx-react";
import { useEffect, useLayoutEffect, useRef } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router";
import { StyleSheetManager } from "styled-components";
import { addDisplayName } from "../Infra/display-name";
import { appFonts, MobileApp, MobileAppWrapper } from "./AppView.styles";
import { CodeBlock, FlexColumn } from "./common.styles";
import { HeaderViewMobile } from "./HeaderViewMobile";
import { HXMobileButton } from "./HXButton";
import { HXPageTitle } from "./HXDesktopPage";
import { Text } from "./HXDesktopPage.styles";
import { Parent } from "./HXMobilePage.styles";
import { createMuiTheme } from "./muiTheme";
import { RouteErrorViewModel } from "./RouteErrorViewModel";
import { useViewModel } from "./useViewModel";
export const RouteErrorView = observer((props) => {
    var _a;
    const model = useViewModel(RouteErrorViewModel, props.container);
    const error = useRouteError();
    const hasRun = useRef(false);
    let errorMessage;
    let stack;
    if (isRouteErrorResponse(error)) {
        errorMessage = (_a = error.data) === null || _a === void 0 ? void 0 : _a.message;
    }
    else if (error instanceof Error) {
        errorMessage = error.message;
        stack = error.stack;
    }
    useLayoutEffect(() => {
        const previous = document.body.style.background;
        document.body.style.background = colors.white_background;
        return () => {
            document.body.style.background = previous;
        };
    }, []);
    useEffect(() => {
        if (hasRun.current)
            return;
        hasRun.current = true;
        if (error instanceof Error && typeof (newrelic === null || newrelic === void 0 ? void 0 : newrelic.noticeError) === "function") {
            newrelic.noticeError(error, { component: "RouteErrorBoundary" });
        }
        model.trackError(errorMessage, stack);
    }, []);
    return (_jsx(StyleSheetManager, { children: _jsx(ThemeProvider, { theme: createMuiTheme(appFonts), children: _jsxs(MobileAppWrapper, { children: [_jsxs(MobileApp, { children: [_jsx(HeaderViewMobile, { container: props.container, showLogoOnly: true }), _jsxs(Parent, { style: { padding: "0 32px 32px 32px", marginTop: 40 }, children: [_jsxs(FlexColumn, { gap: 24, alignItems: "center", children: [_jsx(HXPageTitle, { children: model.title }), _jsx(Text, { children: model.message })] }), _jsxs(FlexColumn, { gap: 12, children: [_jsx(HXMobileButton, { fullWidth: true, onClick: () => window.location.reload(), children: model.reloadButtonText }), _jsx(HXMobileButton, { text: true, fullWidth: true, onClick: () => model.goHome(), children: model.goHomeButtonText })] })] })] }), model.showStackTrace && !!stack && _jsx(CodeBlock, { style: { whiteSpace: "pre-wrap" }, children: stack })] }) }) }));
});
addDisplayName(RouteErrorView, "RouteErrorView");
